import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Radio, Checkbox, DatePicker, Tooltip } from 'antd';
import Translate from 'react-translate-component';
import moment from 'moment';

import RefreshButton from 'components/common/controls/RefreshButton';
import { PERIODS } from 'constants/calendar';
import { DATE_FORMATS } from 'constants/dateFormats';
import { periodConfig, CALENDAR_FILTERS } from 'constants/calendar';
import { momentToFormat } from 'helpers/fieldsHelpers';
import CustomIcon from 'components/common/CustomIcon';

const CalendarFilterOption = ({ icon, translate, value }) => (
    <Tooltip title={<Translate content={translate}/>}>
        <Checkbox value={value}>
            <CustomIcon type={icon}/>
            <Translate content={translate} className="check-name"/>
        </Checkbox>
    </Tooltip>
);

export default class CalendarFilters extends Component {
    static propTypes = {
        date: PropTypes.object,
        period: PropTypes.string,
        filters: PropTypes.array,
        planner: PropTypes.bool,
        refreshMeta: PropTypes.object,
        handleRefresh: PropTypes.func,
        filterHandlers: PropTypes.object,
        education: PropTypes.bool,
        educationPermitted: PropTypes.bool,
    }

    renderPeriod = () => {
        const { period, date, filterHandlers: { onDateSelect } } = this.props;

        let format = '';
        if (period === PERIODS.DAY) {
            format = DATE_FORMATS.fullDayDateFormat;
        } else {
            const { dateFrom, dateTo } = periodConfig[period].getFromToObj(date);
            const isSame = dateFrom.isSame(dateTo, 'month');
            format = `[${ momentToFormat(dateFrom, isSame && DATE_FORMATS.dayFormat) } - ${ momentToFormat(dateTo) }]`;
        }

        return (
            <div className="calendar-datepicker">
                <DatePicker
                    getCalendarContainer={(el) => el.parentNode}
                    onChange={onDateSelect}
                    allowClear={false}
                    format={format}
                    value={date}
                />
            </div>
        );
    };

    render() {
        const { period, filters, planner, refreshMeta } = this.props;
        const { handleRefresh, filterHandlers } = this.props;
        const { education, educationPermitted } = this.props;

        return (
            <div className="calendar-bar">
                <Button
                    onClick={() => filterHandlers.onDateSelect(moment())}
                    className="today"
                    ghost
                    size="small">

                    <Translate content='calendar.today'/>
                </Button>

                <Button onClick={filterHandlers.onPreviousPeriodClick} ghost size="small" icon={<CustomIcon type='angle-left' />} />
                    {this.renderPeriod()}
                <Button onClick={filterHandlers.onNextPeriodClick} ghost size="small" icon={<CustomIcon type='angle-right' />} />

                <Radio.Group
                    onChange={filterHandlers.onPeriodChange}
                    className="radio-bg-group"
                    size="small"
                    value={period}>

                    <Radio.Button value={PERIODS.DAY}>
                        <Translate content='calendar.day'/>
                    </Radio.Button>
                    <Radio.Button value={PERIODS.WEEK5}>
                        <Translate content='calendar.week5'/>
                    </Radio.Button>
                    <Radio.Button value={PERIODS.WEEK7}>
                        <Translate content='calendar.week7'/>
                    </Radio.Button>
                </Radio.Group>

                <Checkbox.Group onChange={filterHandlers.onFiltersChange} value={planner ? [] : filters} className="checkbox-btn-group m-r-15" >
                    <CalendarFilterOption icon="calendar-o" translate='calendar.events' value={CALENDAR_FILTERS.SOTRMEET} />
                    <CalendarFilterOption icon="calendar-like" translate='calendar.personal' value={CALENDAR_FILTERS.PRIVATE} />
                    <CalendarFilterOption icon="phone-lg" translate='calendar.conversations' value={CALENDAR_FILTERS.TELCNT} />
                    <CalendarFilterOption icon="meet" translate='calendar.meetings' value={CALENDAR_FILTERS.MEETINGS} />
                </Checkbox.Group>

                <div className="checkbox-btn-group checkbox-planner">
                    <Checkbox checked={planner} onChange={filterHandlers.onPlannerChange}>
                        <Translate content='calendar.planner'/>
                    </Checkbox>
                </div>

                { educationPermitted && <div className="checkbox-btn-group checkbox-education">
                    <Tooltip title={<Translate content='calendar.education'/>}>
                        <Checkbox checked={education} onChange={filterHandlers.onEducationChange}>
                            <CustomIcon type='graduation-cap'/>
                            <Translate content='calendar.education' className="check-name"/>
                        </Checkbox>
                    </Tooltip>
                </div> }

                <span className="text-right icon-bar">
                    <RefreshButton refreshMeta={refreshMeta} handleRefresh={handleRefresh} />
                </span>
            </div>
        );
    }
}
